import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import { EnvelopeSimple, CheckCircle } from '@phosphor-icons/react';

// Amber strip shown to providers who haven't clicked their verification link yet
export default function EmailVerifyBanner() {
  const { user, token, API } = useAuth();
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  // Vendors don't need to verify email to use Bookr (they go through admin
  // approval instead), so never nag providers. Only unverified non-providers
  // (if any flow ever requires it) would see this.
  if (!user || user.role === 'provider' || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setSent(true);
    } catch (err) { console.error('Resend verification failed:', err); }
    setBusy(false);
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-2xl px-4 py-3 mb-4 flex flex-wrap items-center gap-3" data-testid="email-verify-banner">
      <EnvelopeSimple size={18} className="text-amber-600 shrink-0" />
      <p className="text-sm text-foreground flex-1 min-w-[220px]">
        <span className="font-semibold">Verify your email.</span> We sent a link to <span className="font-medium">{user.email}</span> — click it to activate your account.
      </p>
      {sent ? (
        <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-600" data-testid="verify-resent">
          <CheckCircle size={14} weight="fill" /> Link sent — check your inbox
        </span>
      ) : (
        <button onClick={resend} disabled={busy}
          className="text-xs font-semibold text-amber-700 bg-amber-500/15 hover:bg-amber-500/25 rounded-lg px-3.5 py-2 btn-anim cursor-pointer disabled:opacity-50"
          data-testid="verify-resend-button">
          {busy ? 'Sending…' : 'Resend link'}
        </button>
      )}
    </div>
  );
}
